module.exports = __webpack_public_path__ + "static/media/java.f9c26bfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/java.png
// module id = 123
// module chunks = 0